import React, { useEffect, useMemo, useState } from "react";
import utils from "../../resources/utils";
import { useNavigate } from "react-router-dom";
import constant from "../../resources/constant";
import { shallowEqual, useDispatch, useSelector } from "react-redux";
import {
  hide_loader,
  login_failed,
  set_buiness_list,
  show_loader,
} from "../../actions/app";
import ImageLinks from "../../assets/Images/ImagesLink";
import _ from "lodash";
import api_requests from "../../resources/api_requests";
import Footer from "../../Footer";
import { useOnBusinessSelect } from "../../hooks/auth";
import { useTranslation } from "react-i18next";

const BusinessSelect = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { business_accounts } = useSelector((state) => state.app, shallowEqual);
  const [business_selected, set_business_selected] = useState({});
  const biz_id = utils._retrieveData(constant.SELECTED_BUSINESS_ID);
  const { onBusinessSelect } = useOnBusinessSelect();
  const { t } = useTranslation();

  useEffect(() => {
    const get_business_details = async () => {
      dispatch(show_loader());
      try {
        const business_accounts = (await api_requests.get_business_accounts())
          .data;
        dispatch(set_buiness_list(business_accounts));
        dispatch(hide_loader());
      } catch (err) {
        dispatch(hide_loader());
      }
    };
    if (_.isEmpty(business_accounts) && biz_id) {
      get_business_details();
    } else {
      if (_.isEmpty(business_accounts)) {
        dispatch(login_failed());
      }
    }

    const last_selected_business = utils._retrieveData(
      constant.SELECTED_BUSINESS,
    );
    if (!_.isEmpty(last_selected_business)) {
      set_business_selected(last_selected_business);
    }
  }, []);

  const on_confirm = async () => {
    onBusinessSelect(business_selected);
  };
  const handle_go_back = () => {
    navigate(-1);
  };
  const formatted_biz_account = useMemo(() => {
    const value = _.map(business_accounts, (item) => ({
      ...item,
      business_id: item.id || item.business_id,
    }));
    return value;
  }, [business_accounts]);

  const btn_disable = useMemo(() => {
    return _.isEmpty(business_selected);
  }, [business_selected]);

  const primary = useMemo(() => {
    let color = getComputedStyle(document.documentElement).getPropertyValue(
      "--secondary",
    );
    let primary;
    let secondary;
    let accents;
    if (color == "#E5E5E5" || color == "#e5e5e5") {
      primary = "[#492897]";
      secondary = "[#7953D2]";
      accents = "[#7953D233]";
    }
    return { primary, secondary, accents };
  }, []);

  return (
    <div className="px-6 mt-6">
      {biz_id && (
        <img
          src={ImageLinks.chevron_right}
          className="w-[18px] h-[19px]"
          onClick={handle_go_back}
        />
      )}
      <div className="flex flex-col items-center gap-1 justify-center">
        <p className="font-custom text-2xl font-semibold text-[#7953D2]">
          {t("select_business")}
        </p>
        <p className="font-custom text-sm text-xs font-medium text-dark_gray ">
          {t("kindly_select_your_business_to_begin_your_journey")}
        </p>
      </div>

      <div
        className="mt-4 px-4 flex flex-col gap-2 overflow-auto "
        style={{
          height: `calc(100vh - 280px - env(safe-area-inset-bottom))`,
          minHeight: `calc(100vh - 280px - env(safe-area-inset-bottom))`,
        }}
      >
        {_.map(formatted_biz_account, (val, key) => {
          return (
            <div
              key={key}
              className={`border-2 border-${
                !_.isEmpty(business_selected) &&
                business_selected?.business_id == val?.business_id
                  ? !_.isEmpty(primary.secondary)
                    ? primary.secondary
                    : "secondary"
                  : !_.isEmpty(primary.accents)
                    ? primary.accents
                    : "accents"
              } rounded-lg py-3 px-4`}
              onClick={() => set_business_selected(val)}
              {...(!_.isEmpty(business_selected) &&
                business_selected?.business_id == val?.business_id && {
                  style: {
                    borderColor: !_.isEmpty(primary.accents)
                      ? primary.accents.slice(1, -1)
                      : "",
                    backgroundColor: !_.isEmpty(primary.secondary)
                      ? primary.secondary.slice(1, -1)
                      : "",
                  },
                })}
            >
              <div className="flex justify-between items-center">
                <div className="flex flex-col">
                  <p className="line-clamp-1 font-custom text-sm font-semibold text-dark_black">
                    {val?.brand_name}
                  </p>
                  <p className="line-clamp-1 font-custom text-xs font-medium text-gray">
                    ({val?.business_id})
                  </p>
                </div>
                <img
                  src={
                    !_.isEmpty(business_selected) &&
                    business_selected?.business_id == val?.business_id
                      ? ImageLinks.radio_fill
                      : ImageLinks.radio
                  }
                />
              </div>
            </div>
          );
        })}
      </div>
      <div className="fixed bottom-[80px] left-0 right-0 px-6">
        <button
          onClick={() => on_confirm(business_selected)}
          disabled={btn_disable}
          className={`font-custom w-full py-3 rounded-[30px] text-base font-semibold
            ${
              btn_disable
                ? "bg-gray text-gray-200 cursor-not-allowed"
                : "bg-[#492897] text-white"
            }`}
        >
          {t("confirm")}
        </button>
      </div>
      <Footer bottom={0} bottom_safe_area={true} />
    </div>
  );
};

export default BusinessSelect;
